/**
 * Remove empty size groups from an array of product size groups (as returned from product endpoint)
 *
 * @param  {Array} sizeGroups array of product size groups
 * @return {Array} array of size groups which have at least one sku with inventory available
 */
export default function filterEmptySizeGroups(sizeGroups) {
    return sizeGroups
        .filter(sizeGroup => sizeGroup.includedSkus
            .filter(sku => sku.availableInventory > 0)
            .length > 0,
        );
}
